import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import FiltersBarQuickFiltersItem from './FiltersBarQuickFiltersItem';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NotVisible = styled.div.withConfig({
  displayName: "FiltersBarLayoutManager__NotVisible",
  componentId: "sc-1ch8qbs-0"
})(["visibility:hidden;"]);
const FiltersBarLayoutManager = ({
  fixedComponents,
  // only used for testing
  isVisible,
  onQuickFilterVisibilityChange,
  quickFiltersComponents
}) => {
  const VisiblilityWrapper = isVisible ? View : NotVisible;
  return /*#__PURE__*/_jsx(VisiblilityWrapper, {
    children: /*#__PURE__*/_jsxs(Flex, {
      blockSize: "100%",
      position: "absolute",
      gap: "200",
      children: [/*#__PURE__*/_jsx(View, {
        overflow: "hidden",
        children: Object.entries(quickFiltersComponents).map(([propertyName, quickFilterComponent], index) => /*#__PURE__*/_jsx(FiltersBarQuickFiltersItem, {
          onVisibilityChange: onQuickFilterVisibilityChange(propertyName),
          isFirst: index === 0,
          children: quickFilterComponent
        }, `${propertyName}-filter-bar-layout-manager-filter-component`))
      }), fixedComponents]
    })
  });
};
export default FiltersBarLayoutManager;